<template>
	<div>
		<modalconfirm ref="modalApprovalSRE" @action="proccessSRE"/>
		<div class="text-h5">{{$route.meta.title}}</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-autocomplete :items="SREforApprove" v-model="sre_code" item-value="sre_code" @change="getDetail(sre_code)" label="Sales Penjualan" no-data-text="Tidak ada data yang sesuai" outlined dense @focus="responseError.sre_id = ''" :error-messages="responseError.sre_id" hide-details="auto" class="width-0">
								<template v-slot:item = {item}>
									{{ item.sre_code }} - {{ item.warehouse_name }}
								</template>
								<template v-slot:selection = {item}>
									{{ item.sre_code }}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" v-if="Object.keys(detailSRE).length > 0">
							<div class="font-weight-bold">Detail Warehouse</div>
							<v-row>
								<v-col cols="6" sm="6" md="2">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailSRE.warehouse_name }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="6" md="2">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailSRE.warehouse_mobilephone }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="6" md="4">
									<div class="d-flex">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addresText }}</div>
									</div>
								</v-col>
								<v-col cols="6" sm="6" md="4">
									<div class="d-flex">
										Catatan:
										<div class="pl-3">{{ detailSRE.sre_note }}</div>
									</div>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-data-table disable-pagination :headers="headers" :items="detailSRE.sre_detail" hide-default-footer class="" no-data-text="Tidak ada data tersedia">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.sre_detail_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.sre_detail_product_code }}</div>
								</template>
								<template v-slot:item.product_price="{ item }">
									<div class="pt-2">{{ item.sre_detail_product_price | toNumber }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<div class="pt-2">{{ item.sre_detail_quantity | toNumber }}</div>
								</template>
                <template v-slot:item.total_price="{ item }">
                  <div v-if="item.sre_detail_product_price <= 0">0</div>
                  <div v-else>{{ item.sre_detail_product_price * item.sre_detail_quantity | toNumber }}</div>
                </template>

                <template v-slot:footer v-if="detailSRE.sre_detail">
                  <v-row class="mt-n3">
                    <v-col offset="8">Subtotal</v-col>
                    <v-col class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</v-col>
                  </v-row>
                  <v-row class="mt-n3" v-if="discountTotal > 0">
                    <v-col offset="8">Diskon</v-col>
                    <v-col class="font-weight-bold text-right">{{ discountTotal | toRupiah }}</v-col>
                  </v-row>
                  <v-row class="mt-n3">
                    <v-col offset="8">Total Harga</v-col>
                    <v-col class="font-weight-bold text-right">{{ grandTotal - discountTotal | toRupiah }}</v-col>
                  </v-row>
                  <v-row class="mt-n3">
                    <v-col offset="8">Potongan Harga</v-col>
                    <v-col class="font-weight-bold text-right">{{ detailSRE.sre_rebate_value | toRupiah }}</v-col>
                  </v-row>
                  <v-row class="mt-n3">
                    <v-col offset="8">Total Bayar</v-col>
                    <v-col class="font-weight-bold text-right">{{ (grandTotal - discountTotal - detailSRE.sre_rebate_value) | toRupiah }}</v-col>
                  </v-row>
                </template>

							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" :disabled="!sre_code" outlined class="ml-2 text-capitalize" @click="reject">Tolak</v-btn>
				<v-btn color="primary darken-1" :disabled="!sre_code" depressed class="ml-2 text-capitalize" @click="approve">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			sre_code: '',
			sreProccess: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Harga (Rp)', value: 'product_price', sortable: false},
			{ text: 'Jumlah', value: 'quantity', align: 'end'},
      { text: 'Total Harga (Rp)', value: 'total_price', align: 'end', sortable: false},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('sre', ['detailSRE', 'response', 'responseError', 'SREforApprove']),

		addresText() {
			var data = []
			if (this.detailSRE) {
				if (this.detailSRE.warehouse_address)
					data.push(this.detailSRE.warehouse_address)
				if (this.detailSRE.warehouse_subdistrict_name)
					data.push(this.detailSRE.warehouse_subdistrict_name)
				if (this.detailSRE.warehouse_city_name)
					data.push(this.detailSRE.warehouse_city_name)
				if (this.detailSRE.warehouse_province_name)
					data.push(this.detailSRE.warehouse_province_name)
			}
			return data.join(', ')
		},
    grandTotal(){
			let total = 0
			if (this.detailSRE.sre_detail) {
				this.detailSRE.sre_detail.forEach( (el) => {
					total += el.sre_detail_product_price * el.sre_detail_quantity
				});
			}
			return total
		},
		discountTotal() {
			return this.detailSRE.sre_discount_percent * this.grandTotal / 100
		},
	},
	methods: {
		...mapActions('sre', ['getDetailSRE', 'approveSRE', 'rejectSRE', 'getOptionSREforApprove']),
		...mapMutations('sre', ['setDetailSRE', 'saveResponse']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailSRE({
          sre_code: code
        })
			} else {
				this.setDetailSRE({})
			}
		},
		approve(){
			this.sreProccess = 'approve'
			let msg = "Yakin akan memproses Penjualan ini?"
			this.$refs.modalApprovalSRE.setMessage(msg)
			this.$refs.modalApprovalSRE.showConfirm()
		},
		reject(){
			this.sreProccess = 'reject'
			let msg = "Yakin akan menolak Penjualan ini?"
			this.$refs.modalApprovalSRE.setMessage(msg)
			this.$refs.modalApprovalSRE.showConfirm()
		},
		async proccessSRE() {
			await this.setOverlay(true)
			await this.$refs.modalApprovalSRE.hideConfirm()
      await this.approveSRE({
        sre_id: this.detailSRE.sre_id,
        status: this.sreProccess == 'approve' ? 'approved' : 'rejected',
      }).then(() => {
        if (this.response.code == 200) {
          this.resetForm()
        }
      })

			await this.setOverlay(false)
		},
		resetForm() {
			this.saveResponse({})
			this.sre_code = ''
			this.setDetailSRE({})
      this.getOptionSREforApprove()
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', this.$route.meta.title)
    this.getOptionSREforApprove()
		if (this.$route.params.code) {
			this.sre_code = this.$route.params.code
			this.getDetailSRE(this.$route.params.code)
		}
	},
	watch: {
	}
}
</script>
